module.exports = __webpack_public_path__ + "static/media/rightms.b9461eae.png";